// UI do importer de processos: dropzone → preview → commit.

import { carregarCsv, carregarXlsx, normalizarLinha, importarProcessos } from './lex-import.js';
import { escapeHtml, fmtBRL, fmtDate } from './utils.js';

export function renderDropzoneEPreview({ onCancel, onSuccess }) {
  const wrap = document.createElement('div');
  wrap.innerHTML = `
    <p style="margin:0 0 14px 0;color:rgba(255,255,255,0.75);font-size:13px">
      Aceita <strong>.csv</strong> e <strong>.xlsx</strong>. Colunas mínimas:
      <code>numero_cnj</code> e <code>cnpj_icaro</code>. Tribunal, tipo e área são
      inferidos automaticamente. Idempotente — rodar 2× não duplica (upsert por CNJ).
    </p>

    <div class="lex-dropzone" id="lex-dz">
      <strong>Clique para escolher um arquivo</strong> ou arraste aqui
      <small>Modelo disponível em <code>themis/data/processos_template.csv</code></small>
      <input type="file" id="lex-dz-input" accept=".csv,.xlsx,.xlsm" hidden />
    </div>

    <div id="lex-preview" style="margin-top:18px;display:none"></div>
  `;

  const foot = document.createElement('div');
  foot.style.cssText = 'display:contents';
  foot.innerHTML = `
    <button type="button" class="lex-btn-secondary" data-act="cancel">Cancelar</button>
    <button type="button" class="lex-btn" id="lex-commit"
            style="width:auto;padding:10px 18px;display:none">
      Gravar processos
    </button>
  `;

  const dz = wrap.querySelector('#lex-dz');
  const fileInput = wrap.querySelector('#lex-dz-input');
  const preview = wrap.querySelector('#lex-preview');
  const commitBtn = foot.querySelector('#lex-commit');

  let normalizadas = [];

  const handleFile = async (file) => {
    if (!file) return;
    preview.style.display = 'block';
    preview.innerHTML = `<div class="lex-empty">Lendo <strong>${escapeHtml(file.name)}</strong>…</div>`;

    let raw;
    try {
      const isCsv = /\.csv$/i.test(file.name);
      raw = isCsv ? await carregarCsv(file) : await carregarXlsx(file);
    } catch (err) {
      preview.innerHTML = `<div class="lex-empty" style="color:#FF8C8C">Erro ao ler: ${escapeHtml(err.message)}</div>`;
      return;
    }

    if (!raw.length) {
      preview.innerHTML = `<div class="lex-empty">Arquivo sem linhas de dados.</div>`;
      return;
    }

    normalizadas = raw.map(normalizarLinha);
    const ok = normalizadas.filter(r => r.ok);
    const nok = normalizadas.filter(r => !r.ok);

    preview.innerHTML = `
      <div class="lex-import-summary">
        <div><div class="num">${raw.length}</div><div class="lbl">linhas lidas</div></div>
        <div><div class="num" style="color:#6FE0A8">${ok.length}</div><div class="lbl">válidas</div></div>
        <div><div class="num" style="color:${nok.length ? '#FF8C8C' : '#fff'}">${nok.length}</div><div class="lbl">com erro</div></div>
      </div>

      ${nok.length ? `
        <div class="lex-import-errors">
          <strong>Linhas inválidas (não serão gravadas):</strong>
          <ul style="margin:6px 0 0;padding-left:18px;list-style:disc">
            ${nok.slice(0, 30).map(r => `<li>${escapeHtml(r.erros.join('; '))}</li>`).join('')}
            ${nok.length > 30 ? `<li>… e mais ${nok.length - 30}</li>` : ''}
          </ul>
        </div>
      ` : ''}

      ${ok.length ? `
        <div style="font-size:11px;letter-spacing:0.08em;text-transform:uppercase;color:rgba(255,255,255,0.55);margin-bottom:8px">
          Preview dos primeiros ${Math.min(ok.length, 10)} processos
        </div>
        <table class="lex-table" style="font-size:12px">
          <thead><tr>
            <th>CNJ</th><th>Área</th><th>Tribunal</th><th>Filial</th>
            <th>Contraparte</th><th>Valor causa</th><th>Risco</th>
          </tr></thead>
          <tbody>
            ${ok.slice(0, 10).map(r => `
              <tr>
                <td>${escapeHtml(r.payload.numero_cnj)}</td>
                <td>${escapeHtml(r.payload.area_codigo || '—')}</td>
                <td>${escapeHtml(r.payload.tribunal || '—')}</td>
                <td>${escapeHtml(r.payload.filial_codigo || '—')}</td>
                <td>${escapeHtml(r.payload.contraparte || '—')}</td>
                <td>${fmtBRL(r.payload.valor_causa)}</td>
                <td>${escapeHtml(r.payload.risco || '—')}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      ` : ''}
    `;

    commitBtn.style.display = ok.length ? '' : 'none';
    commitBtn.textContent = ok.length === 1
      ? 'Gravar 1 processo'
      : `Gravar ${ok.length} processos`;
  };

  // Drag & drop
  dz.addEventListener('click', () => fileInput.click());
  fileInput.addEventListener('change', (e) => handleFile(e.target.files?.[0]));

  ['dragenter', 'dragover'].forEach(ev =>
    dz.addEventListener(ev, (e) => { e.preventDefault(); dz.classList.add('drag'); })
  );
  ['dragleave', 'drop'].forEach(ev =>
    dz.addEventListener(ev, (e) => { e.preventDefault(); dz.classList.remove('drag'); })
  );
  dz.addEventListener('drop', (e) => {
    const file = e.dataTransfer.files?.[0];
    if (file) handleFile(file);
  });

  // Commit
  commitBtn.addEventListener('click', async () => {
    commitBtn.disabled = true;
    commitBtn.textContent = 'Gravando…';
    try {
      const result = await importarProcessos(normalizadas);
      onSuccess?.(result);
    } catch (err) {
      alert('Erro: ' + (err.message || err));
      commitBtn.disabled = false;
    }
  });

  foot.querySelector('[data-act="cancel"]').addEventListener('click', () => onCancel?.());

  return { body: wrap, footer: foot };
}
